<template>
  <div class="login-wrapper">
    <card class="login">
      <img
        :src="require(`../assets/images/${logo}`)"
        alt="Logo de Caribe Metrics"
      />
      <form>
        <!-- <h3 class="error" v-show="error">Datos incorrectos</h3> -->
        <h3 class="error" v-show="error">{{ errorMessage }}</h3>
        <fg-input placeholder="Usuario" v-model="nameVal"></fg-input>
        <fg-input
          placeholder="Contraseña"
          v-model="passwordVal"
          type="password"
          @keyup.enter="checkin"
        ></fg-input>
        <transition name="fade">
          <button class="btn btn-primary" type="button" @click="checkin">
            Iniciar sesión
          </button>
        </transition>
      </form>
      <p>¿Tienes problemas al iniciar sesión?</p>
      <a href="#">Contáctanos</a>
    </card>
    <footer>
      <a
        v-if="googlePremierID"
        target="_blank"
        :href="`https://www.google.com/partners/agency?id=${googlePremierID}`"
      >
        <img
          :src="googlePartnerBadgeImage"
          alt="Badge de Google Partner"
        />
      </a>

      <a href="#">Enviar comentarios</a>
      <p>
        {{ AllRightsReserved }}
        <br />{{ DesignedBy }}
        <br />
        <a href="#"
          ><router-link :to="`/privacy-policy`">Privacy Policy</router-link></a
        >
      </p>
    </footer>
  </div>
</template>
<script>
import Card from "@/components/Card/Card.vue";
import FgInput from "@/components/Inputs/Input.vue";

// AUTHENTICATION
import { ServiceFactory } from "../services";
import { getConfig } from "../services/business_config.service.js";
import jwt_decode from "jwt-decode";
import moment from "moment";
import { BusinessUnitConfig } from "../config/businessUnitConfig";

export default {
  name: "login",
  components: {
    Card,
    FgInput
  },
  data() {
    return {
      errorMessage: "",
      googlePremierID: localStorage.getItem("googlePremierID") || null,
      currentHost: window.location.host,
      nameVal: "",
      DesignedBy: "",
      AllRightsReserved: "",
      passwordVal: "",
      error: false,
      logo: BusinessUnitConfig[window.location.host].logoURL || "logo.svg",
      googlePartnerBadgeImage:""
    };
  },
  beforeCreate() {
    let token = localStorage.getItem("user-token");

    let expirationDate = new Date(
      parseInt(localStorage.getItem("token-expiration"))
    );
    let isAuthenticated =
      token && expirationDate && moment(expirationDate).isAfter(new Date())
        ? true
        : false;
    if (isAuthenticated) {
      const loadingPage = localStorage.getItem("loadingPage");
      this.$router.push({ name: loadingPage || "loading" });
    }
  },
  async created() {
    this.year = new Date().getFullYear();

    const dataDashboard = await getConfig("businessUnitConfig.json");

    const {
      countryId,
      googlePremierID,
      logoURL,
      DesignedBy,
      loadingPage,
      AllRightsReserved = "",
      googlePartnerBadgeImage
    } = dataDashboard[this.currentHost];

    localStorage.setItem("countryId", countryId);
    localStorage.setItem("isAxesa", countryId == 2 ? 1 : 0);
    localStorage.setItem("googlePremierID", googlePremierID);
    localStorage.setItem("loadingPage", loadingPage);
    localStorage.setItem("logoURL", logoURL);
    localStorage.setItem("googlePartnerBadgeImage", googlePartnerBadgeImage);
    this.googlePartnerBadgeImage = googlePartnerBadgeImage;
    this.DesignedBy = DesignedBy;
    this.AllRightsReserved = AllRightsReserved.replace("@year",year);
  },
  methods: {
    checkin: async function() {
      let AuthService = ServiceFactory.createInstance({
        type: "AuthService",
        data: this
      });

      await new Promise((resolve, reject) => {
        try {
          localStorage.removeItem("user-token");
          localStorage.removeItem("token-expiration");
          resolve("Good");
        } catch (error) {
          console.log(
            "SE001 - Ops! Something happened while deleting the old cache data session."
          );
          reject("Error");
        }
      });
      const BusinessUnitIdDR = 1;
      const BusinessUnitIdPR = 2;
      const BusinessUnitIdIP = 3;
      const BusinessUnitId = localStorage.getItem("countryId");
      const userNameWithBusiness = this.nameVal + "|" + BusinessUnitId;
      const token = await AuthService.getToken(
        userNameWithBusiness,
        this.passwordVal
      );

      if (!this.nameVal) {
        this.errorMessage = "Usuario no debe estar vacío";
        this.error = true;
        return;
      }

      if (token.status == 406) {
        this.errorMessage = "Usuario Inactivo";
        this.error = true;
        return;
      }

      if (token.status && token.status != 200) {
        this.error = true;
        this.errorMessage = "Datos incorrectos";
        return;
      }

      this.$axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
      localStorage.setItem("user-token", token);
      localStorage.setItem(
        "token-expiration",
        new Date().setHours(new Date().getHours() + 8)
      );

      if (token === undefined) {
        this.error = true;
        this.errorMessage = "Datos incorrectos";
      } else {
        this.error = false;

        const tokenInfo = jwt_decode(`${token}`);
        localStorage.setItem("roll", tokenInfo.Role);
        localStorage.setItem("subscriberId", tokenInfo.SubscrId);
        localStorage.setItem("userName", tokenInfo.UserName);
        localStorage.setItem("businessUnitId", tokenInfo.BusinessUnitId);
        localStorage.setItem("userEmail", tokenInfo.Email);
        localStorage.setItem("Status", tokenInfo.Status);

        if (tokenInfo.BusinessUnitId === BusinessUnitIdDR) {
          this.$router.push({ name: "loading" });
          localStorage.setItem("logo", "logo.svg");
        } else if (tokenInfo.BusinessUnitId === BusinessUnitIdPR) {
          this.$router.push({ name: "loadingpr" });
          localStorage.setItem("logo", "logo-axesa.svg");
        } else if (tokenInfo.BusinessUnitId === BusinessUnitIdIP) {
          this.$router.push({ name: "loadingip" });
          localStorage.setItem("logo", "logo-ip.svg");
        }
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.error {
  font-family: Helvetica, sans-serif;
  font-size: 20px;
  margin: 10px;
  color: red;
}
.login-wrapper {
  padding: 20px;
  height: 100%;
  background-color: $bkg-color;
  display: flex;
  flex-direction: column;
  position: relative;

  .login {
    width: auto;
    height: fit-content;
    text-align: center;
    margin-bottom: 30px;
    img {
      margin-bottom: 30px;
    }
    .form-group {
      margin-bottom: 20px;
    }
    button {
      margin-bottom: 20px;
    }
  }
  footer {
    width: 100%;
    left: 0;
    bottom: 20px;
    height: 150px;
    text-align: center;
    img {
      width: 100px;
      display: block;
      margin: 0 auto 10px;
    }
    a,
    p {
      font-size: 14px;
    }
  }
}

@include respond-between(ss, sm) {
  .login-wrapper {
    .login {
      width: 350px;
      margin: 0 auto 30px;
    }
    footer {
      position: relative;
      height: fit-content;
    }
  }
}
@include respond-above(sm) {
  .login-wrapper {
    justify-content: center;
    .login {
      width: 350px;
      padding: $big-padding;
      align-self: center;
    }
    footer {
      height: 170px;
      a,
      p {
        font-size: 16px;
      }
      img {
        width: 160px;
      }
    }
  }
}
</style>
